<template>
  <div>
    <v-btn small color="orange" class="white--text" @click="dialog = true" >Get Link</v-btn>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">icon-link</v-icon>
            "{{ plan.product.description }}" link
          </span>
          <v-btn class="mt-2" absolute right depressed  fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="package_link" data-vv-scope="package_link" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-text-field
                  ref="plan_link"
                  v-model="planLink"
                  :label="plan.product.description + ' link'"
                ></v-text-field>
                <input type="hidden" :id="'plan_' + plan.product.id" :value="planLink">
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">Close</v-btn>
          <v-btn color="primary" @click="copyToClipboard(); dialog = false;">Copy & Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'GetPackageLinkBtn',
  props: ['plan'],
  data () {
    return {
      dialog: false,
      planLink: ''
    }
  },
  mounted () {
    this.planLink = window.location.origin + '/plans/' + this.plan.product.name
  },
  methods: {
    copyToClipboard () {
      let testingCodeToCopy = document.querySelector('#plan_' + this.plan.product.id)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        let successful = document.execCommand('copy')
        if (successful) {
          this.$toasted.show('The plan link was successfully copied.')
        } else {
          this.$toasted.show('Failed to copy link. Try to copy by manual.', { type: 'error' })
        }
      } catch (err) {
        this.$toasted.show('Failed to copy link. Try to copy by manual.', { type: 'error' })
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/subscriptions/GetPackageLinkBtn.vue